<template>
    <v-container fill-height
                 fluid
                 grid-list-xl>
        <v-layout justify-center
                  wrap>
            <v-flex xs12 md10>
                <material-card :color="getTitleColorStore"
                               :title="$t('menu_exam_register')"
                               :text="$t('exam_register.subtitle')">
                    <ProgressBar :loading="loading" color="deep-purple accent-4" />
                    <template>
                        <v-container grid-list-md>
                            <v-layout row wrap>

                                <v-flex xs6>

                                    <v-flex xs12 sm12 d-flex>
                                        <v-select v-model="odabranaUslugaKljuc"
                                                  :items="UslugeZaIspit"
                                                  item-text="Ime"
                                                  item-value="DDLKljuc"
                                                  @change="uslugaChange"
                                                  :label="$t('exam_register.service_select_text')"></v-select>
                                    </v-flex>

                                    <v-flex xs12 sm12 md6>
                                        <fieldset>
                                            <legend class="text-xs-left">{{ $t('exam_register.credits_state') }} </legend>

                                            <div class="text-xs-left">
                                                <v-chip>
                                                    <v-avatar class="info white--text font-weight-bold"> {{ getBrojKredita() }}</v-avatar>
                                                    <span class="credits-span"> {{$t('exam_register.credits_overall') }} </span>
                                                </v-chip>
                                            </div>

                                            <div class="text-xs-left">
                                                <v-chip>
                                                    <v-avatar class="error white--text font-weight-bold"> {{ getPotrosenoKredita() }}</v-avatar>
                                                    <span class="credits-span"> {{$t('exam_register.credits_used') }} </span>
                                                </v-chip>
                                            </div>

                                            <div class="text-xs-left">
                                                <v-chip>
                                                    <v-avatar class="success white--text font-weight-bold"> {{ getNaRaspolaganjuKredita() }}</v-avatar>
                                                    <span class="credits-span"> {{$t('exam_register.credits_available') }} </span>
                                                </v-chip>
                                            </div>

                                        </fieldset>

                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <div>
                                            {{ $t('exam_register.exam_term_register_notice1') }} :
                                            <b class="title">20</b>
                                            {{ $t('exam_register.exam_term_register_notice2') }}
                                        </div>

                                        <div>
                                            {{ $t('exam_register.exam_term_unregister_notice1') }} :
                                            <b class="title">2</b>
                                            {{ $t('exam_register.exam_term_unregister_notice2') }}
                                        </div>
                                    </v-flex>

                                </v-flex>

                                <v-flex xs6>
                                    <v-flex xs12>
                                        <v-menu v-model="menu1"
                                                :close-on-content-click="false"
                                                full-width
                                                max-width="290">
                                            <template v-slot:activator="{ on }">
                                                <!--clearable isključio-->
                                                <v-text-field :value="computedDateFrom"
                                                              :label="$t('common.dateFrom')"
                                                              readonly
                                                              v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date"
                                                           @change="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-menu v-model="menu2"
                                                :close-on-content-click="false"
                                                full-width
                                                max-width="290">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field :value="computedDateTo"
                                                              :label="$t('common.dateTo')"
                                                              readonly
                                                              v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="endDate"
                                                           @change="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 d-flex>
                                        <v-select v-model="odabranaPodruznica"
                                                  :items="podruznice"
                                                  item-text="Naziv"
                                                  item-value="Id"
                                                  :label="$t('exam_register.city')"></v-select>
                                    </v-flex>

                                    <v-flex xs12 sm6 md4 d-flex>
                                        <v-btn color="info" small :disabled="loading" v-if="userImaOIB"><span class="white--text" @click="prikaziTermine()"> {{ $t('exam_register.show_exams_terms') }} </span></v-btn>
                                    </v-flex>

                                </v-flex>

                                <div class="card border-danger mb-3">
                                    <h4 class="card-header" style="margin-top: 0; background-color: rgba(220, 53, 69, 0.7);">OBAVIJEST!</h4>
                                    <div class="card-body">
                                        <p>Poštovani polaznici,</p>
                                        <p>
                                            sukladno Zakonu o obrazovanju odraslih Učilište je dužno prijaviti popis kandidata i termine završne provjere ili obrane završnog rada ili provjere ishoda
                                            učenja u sklopu programa vrednovanja.
                                        </p>
                                        <p>
                                            Prema navedenom došlo je do izmjene roka za prijavu ispita putem polazničkog portala te je Učilište propisalo za sve rokove završnih ispita <span style="font-weight: 700">od 21.3.2023.</span> rok za prijavu
                                            završnog ispita <span style="font-weight: 700">20 dana prije datuma održavanja ispita.</span>
                                        </p>
                                        <p>
                                            <span style="font-weight: 700">Podsjećamo također da su prijave moguće do popunjena slobodnih mjesta na roku - kada se popune slobodna mjesta, rok više neće biti dostupan za prijavu.</span>
                                        </p>
                                        <p>
                                            Rok za odjavu ispita je ostao nepromijenjen - 48 sati prije ispitnog roka.
                                        </p>
                                        <p>
                                            <span style="font-weight: 700">Da bi pristupili završnom ispitu morate imati svoje podatke za Polaznički portal.</span>
                                        </p>
                                        <p>
                                            Završne provjere za učioničke i online polaznike provode se <span style="font-weight: 700">isključivo</span> na lokacijama Sveučilišta Algebra (Zagreb, Split, Šibenik, Zadar, Pula, Rijeka, Varaždin, Osijek).
                                        </p>
                                    </div>
                                </div>

                                <v-flex xs12 sm10 md10 d-flex v-if="showBtnDemoExam">
                                    <v-btn color="info" small :disabled="loading"><span class="white--text" @click="posaljiPodatkeNaMyQTest()">{{ $t('exam_register.exam_demo_btn') }}</span></v-btn>
                                    <p style="margin-top:15px; margin-left:5px">{{ $t('exam_register.exam_demo_info') }}</p>
                                </v-flex>

                                <v-flex xs12 d-flex>
                                    <ExamTermsTable :passEvent="prijaviIspitRowEvent" :tableData="termini"></ExamTermsTable>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </template>
                    <ConfirmationDialog ref="confirmationRef" :confirmationButtonText="confirmationButtonText"></ConfirmationDialog>
                    <UnosOIBa ref="unosOibaRef" :povratnaFunkcija="prikaziTermine"></UnosOIBa>
                </material-card>
            </v-flex>

        </v-layout>
    </v-container>

</template>

<script>
    import moment from 'moment';
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import ProgressBar from '../Common/Components/MyToolbarProgressBar.vue';
    import ConfirmationDialog from '../Common/Components/ConfirmationDialog.vue';
    import ExamTermsTable from './exam_register_components/ExamTermsTable.vue'
    import UnosOIBa from './exam_common/UnosOIBa.vue'
    import axios from 'axios'

    export default {
        name: 'ExamRegister',

        data: () => ({
            odabranaPodruznica: -1,
            odabranaUslugaKljuc: [],
            date: new Date().toISOString().substr(0, 10),
            endDate: moment().add('1', 'month').format('YYYY-MM-DD'),
            menu1: false,
            menu2: false,
            loadingUslugeZaIspit: false,
            loadingTermine: false,
            prijavljujemIspit: false,
            termini: [],
            showBtnDemoExam: false
        }),

        computed: {
            ...mapState('app', ['podruznice', 'color', 'currentUser']),
            ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
            ...mapState('examModule', ['UslugeZaIspit']),

            userImaOIB() {
                if (this.currentUser.OIB && this.currentUser.OIB.length == 11) {
                    return true;
                } else {
                    return false;
                }
            },

            confirmationButtonText() {
                return this.$t('exam_register.confirm_button');
            },

            getOdabranaUslugaModel() {
                var result = null;
                if (typeof this.UslugeZaIspit !== 'undefined')
                    result = this.UslugeZaIspit.filter(x => x.DDLKljuc == this.odabranaUslugaKljuc)[0];

                result = typeof result !== 'undefined' ? result : null;
                return result;
            },

            computedDateFrom() {
                return this.date ? this.$moment(this.date).format('DD.MM.YYYY') : ''
            },
            computedDateTo() {
                return this.date ? this.$moment(this.endDate).format('DD.MM.YYYY') : ''
            },

            loading() {
                return this.loadingUslugeZaIspit || this.loadingTermine || this.prijavljujemIspit;
            }
        },

        methods: {
            ...mapMutations('examModule', ['SET_USLUGE_ZA_ISPIT', 'REMOVE_PRIJAVLJENU_USLUGU']),
            getBrojKredita() {
                var data = this.getOdabranaUslugaModel;
                return data !== null ? data.BrojKredita : 0;
            },
            getPotrosenoKredita() {
                var data = this.getOdabranaUslugaModel;
                return data !== null ? data.PotrosenoKredita : 0;
            },
            getNaRaspolaganjuKredita() {
                var data = this.getOdabranaUslugaModel;
                return data !== null ? data.NaRaspolaganjuKredita : 0;
            },

            async dohvatiZadnjuPredbiljezbu() {
                var odabranaUslugaModel = this.UslugeZaIspit.filter(x => x.DDLKljuc == this.odabranaUsluga)[0];
            },
            dohvatiUslugeZaPrijavuIspita() {
                var self = this;
                this.loadingUslugeZaIspit = true;
                this.$fetchDataPromise('/api/Exam/GetUslugeIspita', null)
                    .then(x => {
                        this.SET_USLUGE_ZA_ISPIT(x);
                        this.loadingUslugeZaIspit = false;

                        if (x != null && x.length > 0) {
                            this.odabranaUslugaKljuc = x[0].DDLKljuc;
                            self.odabranaPodruznica = x[0].PodruznicaId != null ? x[0].PodruznicaId : 1;
                        }
                    })
                    .then(x => this.prikaziTermine())
                    .catch(x => { this.loadingUslugeZaIspit = false; this.$displayErrorModal(x) });

            },

            prikaziTermine() {
                // Ispit može prijaviti samo ako ima OIB
                if (!this.currentUser.OIB || this.currentUser.OIB.length != 11) {
                    this.$refs.unosOibaRef.show();
                } else {
                    this.loadingTermine = true;

                    if (typeof this.UslugeZaIspit !== 'undefined') {
                        var datumOd = this.$moment(this.date).format('YYYY-MM-DD');
                        var datumDo = this.$moment(this.endDate).format('YYYY-MM-DD');
                        var historyId = this.getOdabranaUslugaModel != null ? this.getOdabranaUslugaModel.HistoryId : null;
                        var seminarId = this.getOdabranaUslugaModel != null ? this.getOdabranaUslugaModel.SeminarId : null;
                        var podtipId = this.getOdabranaUslugaModel != null ? this.getOdabranaUslugaModel.PodtipId : null;

                        var data = { HistoryId: historyId, StartDate: datumOd, EndDate: datumDo, PodruznicaId: this.odabranaPodruznica, SeminarId: seminarId, PodtipId: podtipId };

                        this.$fetchDataPromise('/api/Exam/GetTermine', data)
                            .then(x => {
                                this.termini = [];
                                this.termini = x;
                                this.loadingTermine = false;
                            })
                            .catch(x => { this.loadingTermine = false; this.$displayError(x) });

                    } else {
                        this.$displayError(this.$t('exam_register.no_education_data'))
                        this.loadingTermine = false;
                    }
                }
            },

            prijaviIspitRowEvent(e) {

                var datum = moment(e.item.Datum).format('DD.MM.YYYY');
                var vrijeme = moment(e.item.TerminOd).format('HH:mm');
                var gradUlica = `${e.item.Ulica}, ${e.item.Grad}`;
                var historyId = this.getOdabranaUslugaModel != null ? this.getOdabranaUslugaModel.HistoryId : null;
                var uspjesnoPoruka = this.$t('exam_register.exam_succesfully_registered');
                var porukaZaEmailBody = this.$t('exam_register.exam_succesfully_registered_email_body', { education: this.getOdabranaUslugaModel.Ime, city: gradUlica, date: datum, term: vrijeme });
                var subject = `${this.$t('exam_register.exam_succesfully_registered_email_subj')}`;

                var callback = (isOk) => {
                    this.prijavljujemIspit = true;

                    if (isOk) {
                        var request = {
                            RasporedZaglavlje_ID: e.item.RasporedZaglavljeId,
                            Kredit_ID: this.getOdabranaUslugaModel.KreditId,
                            EksplicitniPodtip_ID: this.getOdabranaUslugaModel.PodtipId,
                            HistoryId: historyId,
                            body: porukaZaEmailBody,
                            subject: subject,
                            MaxBrojPolaznika: e.item.MaxBrojPolaznika
                        }
                        this.$fetchDataPromise('/api/Exam/PrijaviIspit', request)
                            .then(x => {
                                this.$displaySuccess(uspjesnoPoruka);
                                this.ukloniPrijavljenuUslugu(this.getOdabranaUslugaModel.DDLKljuc);
                                this.prijavljujemIspit = false;
                            })
                            .catch(x => { this.prijavljujemIspit = false; this.$displayError(x) });
                    } else {
                        this.prijavljujemIspit = false;
                    }
                }

                var adresa = `${this.$t('exam_register.classroom')}: ${e.item.Ucionica} <br/> ${this.$t('exam_register.address')}: ${e.item.Ulica}, ${e.item.Grad}`
                var pitanje = this.$t('exam_register.confirm_registration', { name: this.getOdabranaUslugaModel.Ime, date_time: datum + ' ' + vrijeme }) + '<hr/>' + adresa;
                this.$refs.confirmationRef.showDialog(callback, pitanje);
            },
            ukloniPrijavljenuUslugu(kljucUsluge) {
                this.termini = [];
                this.REMOVE_PRIJAVLJENU_USLUGU(kljucUsluge);
            },

            uslugaChange() {
                this.termini = [];
            },

            async posaljiPodatkeNaMyQTest() {

                try {
                    const response = await axios.get('https://myqtest.algebra.hr/api/setDemoAccount.aspx', {
                        params: {
                            ime: this.currentUser.Name,
                            prezime: this.currentUser.Surname,
                            email: this.currentUser.Email,
                            spol: this.currentUser.Spol
                        }
                    })
                    this.$displaySuccess(this.$t('exam_register.exam_demo_success'));
                } catch (error) {
                    this.$displayError(this.$t('exam_register.exam_demo_error'));
                }

            },

            async provjeriPODemoIspit() {

                var result = await this.$fetchDataPromise('/api/Education/GetMyEducation', { Vrsta: 0 }).catch(x => { this.loading(false); this.$displayError(x) });

                var POForDemoExams = ['OMGR_H', 'MGR_H', 'WEBDZ_H', 'OWEBDZ_H', 'ASP_dev_H', 'OASP_dev_H', 'ANDA_DEV_H', 'OANDA_DEV_H', 'OPYT_H', 'PYT_H', 'BE_DEV_H', 'OBE_DEV_H', 'FE_DEV_H', 'OFE_DEV_H', 'UX_H_2', 'OUX_H_2', 'ROP', 'OROP', 'DBA_H', 'ODBA_H', 'OCISCO_MS_H', 'CISCO_MS_H', 'OVI_H', 'VI_H', 'OBIM_H', 'BIM_H', 'BIM_2_H', 'OBIM_2_H', 'RAC_PK_H', 'ORAC_PK_H', 'RAC_NO_H', 'ORAC_NO_H', 'PYT_DS_H', 'OPYT_DS_H', 'BE_DEV_J_H', 'OBE_DEV_J_H', 'KTD_H', 'OKTD_H', 'VPR_H', 'OVPR_H', 'OPYT_DEV_H', 'PYT_DEV_H', 'APRS_H', 'OAPRS_H'];

                if (typeof result !== 'undefined') {
                    var polaznikPoList = result.map(o => o.Naziv);
                    this.showBtnDemoExam = polaznikPoList.some(po => POForDemoExams.includes(po));
                }
            },

        },
        mounted() {
            this.dohvatiUslugeZaPrijavuIspita();
            this.provjeriPODemoIspit();
        },
        components: {
            ProgressBar, ExamTermsTable, ConfirmationDialog, UnosOIBa
        }

    }
</script>


<style>
    /* Sređujem nevidljiva slova u calendar pickeru */
    td .v-btn, .v-btn__content {
        color: grey !important;
    }

    .credits-span {
        width: 100px;
    }
</style>



// WEBPACK FOOTER //
// VueSrc/Exams/ExamRegister.vue